module.exports = __webpack_public_path__ + "assets/merriweather-italic.c73604d45ef99540503f3c233d360090.woff";